<div class="appointment-tabs" *ngIf="appointment.isOpenBlockTab && isApptRequestPortalEnabled">
  <div class="btn-group" role="group" aria-label="Basic example">
    <button type="button" class="btn btn-outline-secondary" [ngClass]="[appointmentTab ? 'active' : '']"
      (click)="showAppointment('appointment')">
      <i class="far fa-calendar-check mr-2"></i>Appointments
    </button>
    <button type="button" class="btn btn-outline-secondary" [ngClass]="[blockTab ? 'active' : '']"
      (click)="showAppointment('block')"><i class="fas fa-ban mr-2"></i>Block availability</button>
  </div>
</div>

<app-block-appointment-dialog *ngIf="blockTab && appointment.isOpenBlockTab && isApptRequestPortalEnabled"
  [appointment]="appointment" (onSubmit)="handleBlockAppointment($event)"></app-block-appointment-dialog>

<div *ngIf="appointmentTab" class="add-appointment">
  <div class="icon-bar">
    <div class="icon calendar-icon mt-m10px" [ngClass]="{ active: acFocus.calendar }">
      <i class="fal fa-calendar-day" [ngClass]="{ 'font-400': acFocus.calendar }"></i>
    </div>

    <div class="icon customer-icon" [ngClass]="{ active: acFocus.customer }">
      <i class="fal fa-user" [ngClass]="{ 'font-400': acFocus.customer }"></i>
    </div>

    <div class="icon vehicle-icon" [ngClass]="{ active: acFocus.vehicle }">
      <i class="fal fa-car" [ngClass]="{ 'font-400': acFocus.vehicle }"></i>
    </div>

    <div class="icon task-icon" [ngClass]="{ active: acFocus.estimate }">
      <i class="fal fa-tasks" [ngClass]="{ 'font-400': acFocus.estimate }"></i>
    </div>

    <div *ngIf="isCustomerConcernEnabled" class="icon user-note" [ngClass]="{ active: acFocus.concern }">
      <img src="assets/img/customer-concern-outline.svg" style="height: 20px;" class="mt-2" alt="">
    </div>

    <div class="icon user-icon flex-important flex-center-center" [ngClass]="{ active: acFocus.user }">
      <i class="fal fa-user-hard-hat" [ngClass]="{ 'font-400': acFocus.user }"></i>
    </div>

    <div class="icon user-note" *ngIf="appointmentRequest">
      <i class="fal fa-comment-alt-minus"></i>
    </div>

    <div class="icon user-note" [ngClass]="{ active: acFocus.note }">
      <i class="fal fa-sticky-note" [ngClass]="{ 'font-400': acFocus.note }"></i>
    </div>
  </div>

  <div class="ui-g appt-right-content">
    <div class="ui-g-12 p-0">
      <div class="ui-g-12 ui-lg-4 p-zero left-box pl-2 pt-0 my-3" #addAppointemnt>
        <div class="ui-g-12 p-zero">
          <div class="appointment-time-row flex-start-center mt-0">
            <!-- Start Date -->
            <div>
              <div
                class="form-group appointment-form-group appointment-calendar from-calender border-bottom-white calendar-dropdown"
                [ngClass]="{ 'border-bottom-error': validate.time }" #startDateCalendarContainer>
                <p-calendar id="start-date" dateFormat="M dd, yy" [(ngModel)]="appointment.date.start"
                  (onFocus)="onFocusInput('calendar')" (onBlur)="onBlurInput('calendar')"
                  (onSelect)="onSelectStartDate($event)" #startDateCalendar>
                </p-calendar>
              </div>
            </div>

            <!-- Start Time -->
            <div>
              <div class="form-group appointment-form-group appointment-time pl-4px border-bottom-white"
                [ngClass]="{ 'border-bottom-error': validate.time }">
                <app-dropdown id="start-time" listId="start-time-list" idKey="i" field="label" scrollHeight="152px"
                  theme="light" styleClassSelectedView="time-dropdown" itemWidth="150px"
                  styleClassDropdownList="border-none" [autoFocus]="focus?.startTime" [hasBorderBottomOnActive]="false"
                  [options]="times" [setPositionDynamically]="false" [fontSize]="14" [isInline]="true"
                  [value]="selectedTime.start" [focusOnSelectedValue]="true" [isDropdownIconVisible]="false"
                  (appSelect)="onSelectStartTime($event)" (appOpenDropdown)="onFocusInput('startTime')"
                  (appClickOutside)="handleBlur('startTime')">
                </app-dropdown>
              </div>
            </div>

            <!-- To -->
            <div class="text-center">
              <p class="m-0 font-12">
                <i class="fal fa-minus"></i>
              </p>
            </div>

            <div>
              <div class="form-group appointment-form-group appointment-time pr-4px border-bottom-white"
                [ngClass]="{ 'border-bottom-error': validate.time }">
                <app-dropdown id="end-time" listId="end-time-list" idKey="i" field="label" theme="light"
                  itemWidth="150px" scrollHeight="152px" inactiveItemsKey="isActiveEndTime"
                  styleClassDropdownList="time-box-shadow" [hasBorderBottomOnActive]="false"
                  [autoFocus]="focus?.endTime" [focusOnSelectedValue]="true" [fontSize]="14"
                  [setPositionDynamically]="false" [hasCustomItemTemplate]="true" [isInline]="true"
                  [options]="endTimeDropdown" [value]="selectedTime.end" [isDropdownIconVisible]="false"
                  [selectInactiveItems]="false" (appSelect)="onSelectEndTime($event)"
                  (appOpenDropdown)="onFocusInput('endTime')" (appClickOutside)="handleBlur('endTime')">
                  <ng-template let-item appTemplate="item">
                    <span class="font-12" [ngClass]="{ 'disabled-endTime': !item?.isActiveEndTime }">
                      {{ item?.diffTime ? item?.diffTime : item?.label }}
                    </span>
                  </ng-template>
                </app-dropdown>
              </div>
            </div>

            <!-- End Date -->
            <div>
              <div
                class="form-group appointment-form-group appointment-calendar to-calender border-bottom-white calendar-dropdown"
                [ngClass]="{ 'border-bottom-error': validate.time }">
                <p-calendar id="end-date" dateFormat="M dd, yy" [minDate]="appointment.date.start"
                  [(ngModel)]="appointment.date.end" (onSelect)="onEndDateSelect()" (onFocus)="onFocusInput('calendar')"
                  (onBlur)="onBlurInput('calendar')" #endDateCalendar>
                </p-calendar>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-zero notes-sections">
          <div class="ui-g-12 p-zero min-hight45 flex-start-center">
            <div class="appointment-customer-autocomplete width-100p">
              <i class="fal fa-times customer-delete-icon pointer" (click)="removeCustomer()"
                *ngIf="appointment.customer.customerId"></i>
              <app-auto-complete id="ac-appt-customer" listId="ac-appt-customer-list" placeholder="Search customer"
                theme="light" scrollHeight="192px" inactiveItemsKey="isActive" noRecordIcon="fal fa-user font-16 pr-2"
                noRecordText="No customers match your search" [isLoading]="isLoading"
                [styleClassInput]="appointment?.customer?.customerId && 'h-underline text-ellipse'"
                [disabled]="appointment?.customer?.customerId" [showDisabledIcon]="false"
                [suggestions]="customerSearchResults" [closeOnSelection]="true" [hasEditableField]="true"
                [defaultSuggestions]="defaultCustomerSearch" [fontSize]="14" [hasCustomEditableField]="true"
                [value]="customerSearchKey" [selectInactiveItems]="false" [autoFocus]="isCustomerFocused"
                (appSelect)="onSearchSelect($event)" (appFocus)="onFocusInput('customer')"
                (appBlur)="handleBlur('customer')" [hasListHeaderData]="appointmentRequest"
                (appCompletedMethod)="customerSearch($event)" (appClear)="onSearchClear()"
                [imgIcon]="helperService.showMFCIconOnInput(customer)"
                (appClickInput)="openCustomerInSidePanel('edit', 'customer', null)"
                (appChange)="onCustomerSearchChange($event)"
                (appShiftTabPress)="openStartDateTime(startDateCalendar, endDateCalendar, $event)"
                (scroll)="handleScroll()">
                <ng-template let-item appTemplate="editable">
                  <div id="btn-appt-create-customer" class="font-12" (click)="addNewCustomer()"> Create new customer
                  </div>
                </ng-template>

                <ng-template let-item appTemplate="item">
                  <div class="search-item" (click)="!item?.isActive ? $event.stopPropagation() : null"
                    [ngClass]="{ disabled: !item?.isActive }">
                    <div class="font-12">
                      <img [src]="helperService.showMFCIconOnInput(item)" class="mr-1 width-20px"
                        *ngIf="helperService.showMFCIconOnInput(item)" />
                      <b>{{ item.fullNameQBO }}</b>&nbsp;{{ item.phone | mask : '(000) 000-0000' }}
                      <br />
                      {{ item.email }}
                    </div>
                    <!-- show driver names -->
                    <div class="flex-column" *ngIf="item?.drivers?.length">
                      <ng-container *ngFor="let driver of item?.drivers">
                        <div class="font-600 text-blue" *ngIf="customerSearchData && checkDriverWithSearchedField(driver)">
                          Driver: <span class="truncate" [innerHTML]="driver.driverName | highlighter:query:'partial'"></span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>

              <div class="globe-icon" (click)="toggleLanguageDropdown()"
                *ngIf="companyLocalization && appointment?.customer?.customerId">
                <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
                <span class="lang">
                  {{currentLang?.toUpperCase()}}
                </span>
                <div *ngIf="isLanguageDropdownVisible" class="language-dropdown">
                  <div (click)="switchLanguage('en')">
                    English
                  </div>
                  <div (click)="switchLanguage('fr')">
                    French (Français)
                  </div>
                </div>
              </div>

              <div class="pinned-notes-container appointment-notes" *ngIf="appointment?.customer?.customerId">
                <app-content-overlay *ngIf="appointment?.customer?.customerId" arrowTop="-5px" arrowRight="10px"
                  right="-50px" [showArrow]="true" [showOnHover]="true" [defaultState]="appointment?.customer?.notes">
                  <ng-template appTemplate="item">
                    <span class="pinned-notes-wrapper pl-2 pr-2" (click)="openCustomerInSidePanel('scroll-to-notes')">
                      <i class="fal fa-sticky-note pinned-notes pointer font-gray"></i>
                    </span>
                  </ng-template>

                  <ng-template appTemplate="overlay" let-close="close">
                    <div
                      class="ui-tooltip ui-widget ui-tooltip-bottom ticket-tooltip estimate modifier technician-size completed"
                      style="display: inline-block; left: -239px; max-width: 230px; top: 13px; opacity: 1.036; z-index: 1011">
                      <div class="ui-tooltip-arrow"></div>
                      <div class="ui-tooltip-text ui-shadow ui-corner-all">
                        <div class="tooltip-seondary">
                          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 divider-bottom"><i
                              class="fal fa-sticky-note"></i>Pinned note</div>
                          <div class="tooltip-2">
                            <div class="tooltip-secondary-row seondary-row-padding font-12 font-gray-35 d-flex">
                              <i class="fal fa-user align-self-start" style="margin-top: 2px"></i>
                              <div class="tech-service font-800 font-gray-35 pinned-text-wrap">
                                {{ appointment?.customer?.notes || 'No notes added' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-content-overlay>
              </div>

              <i id="appt-remove-customer" class="fal fa-times pointer font-gray" (click)="removeCustomer()"
                *ngIf="appointment.customer.customerId"></i>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-zero">
          <div class="ui-g-12 p-zero min-hight45 flex-start-center">
            <div class="form-group appointment-vehicle-dropdown width-100p">
              <app-auto-complete id="d-appt-vehicle" listId="d-appt-vehicle-list" placeholder="Search vehicle"
                theme="light" scrollHeight="245px" inactiveItemsKey="isActive" noRecordIcon="fal fa-car font-16 pr-2"
                noRecordText="No vehicles match your search" [isLoading]="isLoading"
                [styleClassInput]="appointment?.vehicle?.vehicleId && 'text-ellipse'"
                [disabled]="appointment?.vehicle?.vehicleId" [showDisabledIcon]="false"
                [suggestions]="vehicleSearchResults" [closeOnSelection]="true" [hasEditableField]="true" [fontSize]="14"
                [hasCustomEditableField]="true" [value]="selectedVehicle?.name || appointmentReqVehicle?.name"
                [selectInactiveItems]="false" [autoFocus]="focus.vehicle" [hasCustomListTemplate]="true"
                (appClickInput)="selectedVehicle?.name ? openCustomerInSidePanel('','vehicle', appointment?.vehicle?.vehicleId) : null"
                (appFocus)="onFocusInput('vehicle'); vehicleSearch('')" (appBlur)="handleBlur('vehicle')"
                (appChange)="vehicleSearchData = $event" (appCompletedMethod)="vehicleSearch($event)"
                (appClear)="vehicleSearch('')">
                <!-- (appSelect)="onSelectVehicle($event)" -->
                <!-- <ng-template let-item appTemplate="item">
                  <div class="flex-column font-12" [ngClass]="{ 'inactive-vehicle': !item?.isActive }">
                    <span class="font-13 font-600">{{ item?.name }}</span>

                    <span class="font-12">
                      <span>License: {{ item?.licensePlateNo || noLicense }}</span>
                      <span> - </span>
                      <span>VIN: <span [innerHTML]="item?.VIN || noVIN | highlightVin"></span></span>
                    </span>
                  </div>
                </ng-template> -->

                <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
                  <li class="font-12 font-600 p-2 bt-1 source-suggestions-label active-vehicle-header"
                    *ngIf="vehicleType?.active?.length > 0">
                    <p class="mb-0">Active vehicles</p>
                  </li>
                  <li class="source-suggestions-local">
                    <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                      <li class="font-12 font-black p-2 source-suggestion-label"
                        *ngFor="let item of vehicleType?.active; let i = index" id="item-{{ i }}"
                        (click)="onSelectVehicle(item, close)">
                        <span class="search-item d-flex">
                          <div class="flex-column font-12" [ngClass]="{ 'inactive-vehicle': !item?.isActive }">
                            <span class="font-13 font-600 inactive-item-name">{{ item?.name }}</span>

                            <span class="font-12 inactive-item-number">
                              <span>License: {{ item?.licensePlateNo || noLicense }}</span>
                              <span> - </span>
                              <span>VIN: <span [innerHTML]="item?.VIN || noVIN | highlightVin"></span></span>
                            </span>
                          </div>
                        </span>
                      </li>
                    </ul>
                  </li>

                  <li class="font-12 font-600 p-2 bt-1 source-suggestions-label in-active-header"
                    *ngIf="vehicleType.inactive?.length > 0">
                    <p class="mb-0">Inactive vehicles</p>
                  </li>
                  <li class="source-suggestions-local in-active-list">
                    <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                      <li class="font-12 font-black p-2 source-suggestion-label archived"
                        *ngFor="let item of vehicleType?.inactive; let j = index" id="item-{{ j }}">
                        <span class="search-item d-flex">
                          <div class="flex-column font-12" [ngClass]="{ 'inactive-vehicle': !item?.isActive }">
                            <span class="font-13 font-600 inactive-item-name">{{ item?.name }}</span>

                            <span class="font-12 inactive-item-number">
                              <span>License: {{ item?.licensePlateNo || noLicense }}</span>
                              <span> - </span>
                              <span>VIN: <span [innerHTML]="item?.VIN || noVIN | highlightVin"></span></span>
                            </span>
                          </div>
                        </span>
                      </li>
                    </ul>
                  </li>
                </ng-template>

                <ng-template let-item appTemplate="editable">
                  <div id="appt-add-vehicle" class="" (click)="addNewVehicle()">Add vehicle</div>
                </ng-template>
              </app-auto-complete>

              <div *ngIf="isTireStorage2Enabled && appointment?.vehicle?.vehicleId" class="tire-storage-icon"
                tooltipPosition="top" [pTooltip]="tireStorages?.length ? 'View stored tires' : 'No stored tires'"
                [ngClass]="{'not-allowed': !tireStorages?.length}"
                (click)="!isLoadingTirestorageData ? openTireStorageSideDrawer() : ''">
                <i class="fa fa-spinner rotate" *ngIf="isLoadingTirestorageData"></i>
                <img *ngIf="!isLoadingTirestorageData"
                  [src]="tireStorageInspectionIcons[tireStorageInspectionStatus]" />
                <span *ngIf="!isLoadingTirestorageData" class="tire-count-badge"
                  [ngClass]="tireStorageInspectionStatus">{{tiresInfoCount}}</span>
              </div>
              <i id="appt-remove-vehicle" class="fal fa-times pointer font-gray" (click)="removeVehicle()"
                *ngIf="appointment?.vehicle?.vehicleId"></i>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-zero">
          <div class="ui-g-12 p-zero min-hight45 flex-start-center">
            <div class="form-group appointment-estimate-autocomplete width-100p">
              <app-dropdown id="d-appt-ro" listId="d-appt-ro-list" idKey="i" field="label"
                placeholder="Select repair order" scrollHeight="120px" theme="light" [hasBorderBottomOnActive]="false"
                itemWidth="150px" [autoFocus]="focus.order" [hidden]="!appointment?.customer?.customerId"
                [disabled]="appointment?.estimate?.estimateId" [hasCustomItemTemplate]="true"
                [options]="estimateSearchResults" [setPositionDynamically]="false" [fontSize]="14" [isInline]="true"
                [value]="{ label: estimateSearchKey }" [focusOnSelectedValue]="false"
                [isDropdownIconVisible]="!appointment?.estimate?.estimateId" (appSelect)="onEstimateSelect($event)"
                (appOpenDropdown)="onFocusInput('estimate')"
                (click)="appointment?.estimate?.estimateId ? openRepairOrder(appointment?.estimate?.estimateId) : null">
                <ng-template let-item appTemplate="item">
                  <div class="flex-between-center">
                    <span class="font-600 font-12">{{ item?.title || defaultTitle }}</span>
                    <span class="font-600 font-12">{{ item?.code }}</span>
                  </div>
                </ng-template>
                <ng-template let-item appTemplate="editable">
                  <div id="btn-appt-create-repair-order" class="font-12" (click)="onAddEstimate()">Add Repair Order
                  </div>
                </ng-template>
              </app-dropdown>

              <app-auto-complete id="ac-appt-estimate" listId="ac-appt-estimate-list" placeholder="Search repair order"
                scrollHeight="60px" theme="light" [hidden]="appointment?.customer?.customerId" [hasEditableField]="true"
                [hasCustomEditableField]="true" [fontSize]="14" [isSetPositionDynamically]="false"
                [value]="estimateSearchKey" [suggestions]="estimateSearchResults" [closeOnSelection]="true"
                (appSelect)="onEstimateSelect($event)" (appCompletedMethod)="estimateSearch($event)"
                (appClear)="onEstimateClear()" (appFocus)="onFocusInput('estimate')">
                <ng-template let-item appTemplate="item">
                  <div class="flex-between-center">
                    <span class="font-600">{{ item?.title || defaultTitle }}</span>
                    <span class="font-600">{{ item?.code }}</span>
                  </div>
                </ng-template>
                <ng-template let-item appTemplate="editable">
                  <div id="appt-add-estimate" class="font-12" (click)="onAddEstimate()">Add Repair Order</div>
                </ng-template>
              </app-auto-complete>

              <i id="appt-remove-estimate" class="remove-order z-index-99 fal fa-times pointer font-gray"
                (click)="removeOrder($event)"
                *ngIf="appointment?.estimate?.estimateId && !appointment?.estimate?.isTireScheduleForReturn"></i>
            </div>
          </div>
        </div>

        <div *ngIf="isCustomerConcernEnabled" class="ui-g-12 p-zero pr-2 h-auto multiple-customer-concerns">
          <div *ngFor="let concernItems of concern; let concernIndex = index"
            class="ui-g-10 p-0 width-100p flex-start-start mb-2"
            [ngClass]="concernItems?.notes || acFocus.concern ? 'notes-exists' : 'empty-notes'">
            <div class="concern-counter" *ngIf="acFocus.concern || concernItems?.notes">{{concernIndex + 1}}</div>
            <div class="form-group font-14 mb-20 width-100p customer-concern-wrapper position-relative"
              [ngClass]="{'expanded': concernItems.expanded}">
              <!-- {{concernItems.expanded}} -->
              <!-- [ngClass]="{ active: acFocus.concern }" -->

              <app-textarea [ngClass]="{'pb-for-view-btn' : concernItems?.notes?.length > 115}" id="appt-concerns"
                [textAreaId]="'VcustomerConcern'+concernIndex+1" type="text" theme="primary" placeholder="Add a concern"
                name="concerns" [value]="concernItems?.notes" [floatingLabel]="false" [autoGrow]="true"
                [maxAutoGrowHeight]="120" [disabled]="isMultiLocationEnabled" [rows]="1" [fontSize]="13"
                [maxLength]="2000" [autoFocus]="acFocus.concern && focusConcern[concernIndex]?.concern"
                [isInvalid]="errorsConcern[concernIndex]?.notes" (appFocus)="onFocusInput('concern', concernIndex)"
                (appBlur)="handleBlur('concern', concernIndex)"
                (keyup)="concernChange($event.target.value, $event, concernIndex)"></app-textarea>

              <!-- View more button -->
              <div class="view-more-cc" *ngIf="concernItems?.notes?.length > 115"
                (click)="toggleRowExpansion(concernIndex)">
                View <span>&nbsp;{{(concernItems.expanded && concernItems?.notes?.length > 115) ? 'less' : 'more'}}
                </span><i class="far"
                  [ngClass]="(concernItems.expanded && concernItems?.notes?.length > 115) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </div>
            </div>
            <i class="delete-concern fas fa-trash pointer" *ngIf="concernItems?.notes?.length"
              (click)="deleteConcern(concernItems,concernIndex)"></i>
          </div>

          <!-- Add another concern -->
          <div class="add-concern" id="add-another-concern"
            (click)="handleAddConcern('concern')">
            <i class="fal fa-plus-circle fa-fw"></i>
            Add another concern
          </div>
        </div>

        <div class=" ui-g-12 p-zero">
          <div class="ui-g-12 p-zero min-hight45 flex-start-center">
            <div class="form-group width-100p technician-multi-select"
              [ngClass]="{ 'technician-selected-color': selectedTechnician.length > 0 }">
              <app-multiselect id="ms-appt-technician" listId="ms-appt-technician-list" field="label" vPosition="top"
                itemWidth="200px" scrollHeight="134px" headerTitle="Select Technicians" placeholder="Select technicians"
                [hasBgOnActive]="true" [hasHoverEffect]="true" [values]="selectedTechnician" [fontSize]="14"
                [selectionLimit]="20" [options]="technician" (appSave)="handleSelectTechnician($event)"
                (appOpenDropdown)="scrollToBottom()">
              </app-multiselect>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-zero" *ngIf="appointmentRequest">
          <div class="ui-g-10 p-zero min-hight45 width-100p flex-start-center">
            <div class="form-group font-14 mb-20 notes width-100p pl-1" #target [ngClass]="{ active: acFocus.note }"
              (click)="appointRequest(target)">
              APR# {{ appointmentRequest.code }} {{ appointmentRequest.customer.firstName }}
              {{ appointmentRequest.customer.lastName }}
              <i class="fal fa-external-link ml-1"></i>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-zero">
          <div class="ui-g-10 p-0 width-100p flex-start-center">
            <div class="form-group font-14 mb-20 notes width-100p" [ngClass]="{ active: acFocus.note }">
              <textarea id="appt-notes" name="notes" [(ngModel)]="appointment.notes" [maxLength]="2000"
                (keyup)="notesChange($event.target.value, $event)" placeholder="Notes" rows="4" class="pt-2 mt-1"
                required></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g-12 ui-lg-5 contact-section right-box bg-light-gray">
        <div class="mt-1">
          <div *ngIf="appointment?.customer?.customerId && isMarketingEnabled">
            <p class="font-14 font-secondary-900 font-bold mb-2">Source campaign</p>
            <app-auto-complete theme="border" styleClassInputWrapper="p-2 pl-2 text-transform-uppercase"
              styleClassListWrapper="top-38 width-100p" listId="group-list-search-list" styleClassError="top-35 left-10"
              inactiveItemsKey="status" scrollHeight="330px" noRecordText="No items match your search" field="title"
              textAreaId="campaign-group-textarea" placeholder="SELECT SOURCE CAMPAIGN" [showDisabledIcon]="false"
              [maxAutoGrowHeight]="96" [selectInactiveItems]="false" [selectTextOnFocus]="true" [selectionOnTab]="true"
              [highlightFirstSelectedValue]="true" [autoFocus]="false" [hasCustomListTemplate]="true"
              [isDropdownIconVisible]="false" [hasCustomEditableField]="false"
              [value]="sourceCampaign?.title?.toUpperCase()" [fontSize]="12" [suggestions]="campignSuggestions"
              [closeOnSelection]="true" (appCompletedMethod)="search($event)" (appClear)="onSearchClearMarketing()">
              <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close" appTemplate="list">
                <li class="font-12 font-600 bg-gary-90 p-2 source-suggestions-label"
                  *ngIf="sourceCampaigns?.promotionalCampaigns?.length > 0">
                  <p class="mb-0 font-black">Promotional Campaign</p>
                  <div class="ddl-empty-state-wrapper d-flex w-100 py-2" *ngIf="sourceCampaigns.length === 0">
                    <div class="empty-list-icon font-12 font-gray-75 pr-2 align-self-center">
                      <i class="fal fa-users-class"></i>
                    </div>
                  </div>
                </li>
                <li class="source-suggestions-local">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label"
                      *ngFor="let promotional of sourceCampaigns?.promotionalCampaigns; let i = index" id="item-{{ i }}"
                      (click)="onSearchSelectMarketing(promotional, close)">
                      <div class="flex-column">
                        <div class="flex-between-center">
                          <span class="font-12 font-600 text-initial text-truncate pr-2" tooltipPosition="top"
                            [pTooltip]="promotional?.title">{{ promotional?.title }}</span>
                          <span class="font-11 text-initial font-gray-55">{{ promotional?.type }}</span>
                        </div>

                        <div class="flex-between-center">
                          <span class="font-gray-55 font-11 text-initial"> Last message sent: {{
                            promotional?.sendDate |
                            date : 'MMM d, yyyy' }} </span>
                          <span class="font-gray-55 font-11 text-initial">Promotion</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li class="font-12 font-600 bg-gary-90 p-2 bt-1 source-suggestions-label"
                  *ngIf="sourceCampaigns?.followUps?.length > 0">
                  <p class="mb-0 font-black">Follow-up Campaign</p>

                  <div class="ddl-empty-state-wrapper d-flex w-100 py-2" *ngIf="sourceCampaigns.length === 0">
                    <div class="empty-list-icon font-12 font-gray-75 pr-2 align-self-center">
                      <i class="fal fa-users-class"></i>
                    </div>
                  </div>
                </li>
                <li class="source-suggestions-local">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label"
                      *ngFor="let followup of sourceCampaigns?.followUps; let j = index" id="item-{{ j }}"
                      (click)="onSearchSelectMarketing(followup, close)">
                      <div class="flex-column">
                        <div class="flex-between-center">
                          <span class="font-12 font-600 text-initial text-truncate pr-2" tooltipPosition="top"
                            [pTooltip]="followup?.title">{{ followup?.title }}</span>
                          <span class="font-11 text-initial font-gray-55">{{ followup?.type }}</span>
                        </div>

                        <div class="flex-between-center">
                          <span class="font-gray-55 font-11 text-initial"> Last message sent: {{ followup?.sendDate
                            |
                            date : 'MMM d, yyyy' }} </span>
                          <span class="font-gray-55 font-11 text-initial">Follow-up</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li class="font-12 font-600 bg-gary-90 p-2 bt-1 source-suggestions-label"
                  *ngIf="sourceCampaigns?.leadCampaigns?.length > 0">
                  <p class="mb-0 font-black">Lead Source</p>

                  <div class="ddl-empty-state-wrapper d-flex w-100 py-2" *ngIf="sourceCampaigns.length === 0">
                    <div class="empty-list-icon font-12 font-gray-75 pr-2 align-self-center">
                      <i class="fal fa-users-class"></i>
                    </div>
                  </div>
                </li>
                <li class="source-suggestions-local">
                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                    <li class="font-12 font-black p-2 source-suggestion-label"
                      *ngFor="let lead of sourceCampaigns?.leadCampaigns; let k = index" id="item-{{ k }}"
                      (click)="onSearchSelectMarketing(lead, close)">
                      <div class="flex-column">
                        <div class="flex-between-center">
                          <span class="font-12 font-600 text-initial text-truncate pr-2" tooltipPosition="top"
                            [pTooltip]="followup?.title">{{ lead?.title }}</span>
                          <!-- <span class="font-11 text-initial font-gray-55">{{lead?.category}}</span> -->
                        </div>

                        <div class="flex-between-center">
                          <span class="font-gray-55 font-11 text-initial">
                            {{ lead?.category }}
                          </span>
                          <!-- <span class="font-gray-55 font-11 text-initial">Follow-up</span> -->
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ng-template>
            </app-auto-complete>
            <i class="fal fa-times clear-vehicle-filter-btn p-2 pointer hover" *ngIf="sourceCampaign?.title"
              (click)="clearSourceCampaign($event, sourceCampaign)"> </i>

            <!-- <app-dropdown id="est-workflow-status" listId="est-workflow-status-list" theme="border"
              styleClassSelectedView="p-6p text-transform-uppercase" placeholder="Select source campaign"
              styleClassDropdownListItem="text-transform-uppercase" scrollHeight="198px" field="title"
              [hasCustomItemTemplate]="true" [options]="sourceCampaigns" [isDropdownIconVisible]="true"
              [fullyControlled]="true" [value]="appointment?.followUpCampaign"
              (appSelect)="handleChange('followUpCampaign', $event)">
              <ng-template let-item appTemplate="item">
                <div class="flex-column">
                  <div class="flex-between-center">
                    <span class="font-14 font-bold text-initial text-truncate pr-2" tooltipPosition="top"
                      [pTooltip]="item?.title">{{ item?.title }}</span>
                    <span class="font-11 text-initial">{{ item?.type }}</span>
                  </div>

                  <div class="flex-between-center">
                    <span class="font-gray-35 font-11 text-initial">
                      Last message sent: {{ item?.sendDate | date: 'MMM d, yyyy' }}
                    </span>
                    <span class="font-gray-35 font-11 text-initial">Follow-up</span>
                  </div>
                </div>
              </ng-template>
            </app-dropdown> -->
          </div>
        </div>

        <div *ngIf="!sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)">
          <div class="flex-start-center mb-10 mt-20 disabled">
            <div class="custom-checkbox preferred-contact-check checkbox-style-1">
              <p-checkbox id="appt-contact-email" name="contactOnEmail" styleClass="pr-2 field-checkbox"
                class="checkbox-field" value="true" label="Email" binary="true" inputId="contactOnEmail"
                checkboxIcon="fal fa-check" [(ngModel)]="appointment.customer.contactOnEmail"
                [disabled]="isFetchingContacts || !sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)"
                (onChange)="handleContactPrefChange('contactOnEmail', $event)">
              </p-checkbox>

              <p-checkbox id="appt-contact-phone" name="contactOnPhone" styleClass="field-checkbox"
                class="checkbox-field" value="true" label="SMS" binary="true" inputId="contactOnPhone"
                checkboxIcon="fal fa-check" [(ngModel)]="appointment.customer.contactOnPhone"
                [disabled]="isFetchingContacts || !sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)"
                (onChange)="handleContactPrefChange('contactOnPhone', $event)">
              </p-checkbox>
            </div>
          </div>

          <p class="font-14 font-secondary-900 font-bold mb-2">Confirmation&nbsp;&&nbsp;reminders</p>
          <div class="modal-empty-list reminder-empty">
            <p>Select customer to see confirmation and reminders</p>
          </div>
        </div>
        <div [hidden]="!sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)"
          class="flex-start-center mb-10 mt-20">
          <div class="custom-checkbox preferred-contact-check checkbox-style-1">
            <p-checkbox id="appt-contact-email" name="contactOnEmail" styleClass="pr-2 field-checkbox"
              class="checkbox-field" value="true" label="Email" binary="true" inputId="contactOnEmail"
              checkboxIcon="fal fa-check" [(ngModel)]="appointment.customer.contactOnEmail"
              [disabled]="isFetchingContacts" (onChange)="handleContactPrefChange('contactOnEmail', $event)">
            </p-checkbox>

            <p-checkbox id="appt-contact-phone" name="contactOnPhone" styleClass="field-checkbox" class="checkbox-field"
              value="true" label="SMS" binary="true" inputId="contactOnPhone" checkboxIcon="fal fa-check"
              [(ngModel)]="appointment.customer.contactOnPhone" [disabled]="isFetchingContacts"
              (onChange)="handleContactPrefChange('contactOnPhone', $event)">
            </p-checkbox>
          </div>
        </div>

        <!-- Tabs setup starts -->
        <p-tabView class="apt-confirmation-tabs manual-apt-true" (onChange)="handleTabChange($event)"
          [activeIndex]="index"
          [hidden]="!sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)">
          <!-- Customer Confirmation starts -->
          <p-tabPanel header="Customer Confirmation" [selected]="selectedTab === 0">
            <div>
              <p *ngIf="false"
                [hidden]="!sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)"
                class="font-14 font-secondary-900 font-bold mb-2 ml-1">
                Confirmation&nbsp;&&nbsp;reminders
              </p>

              <!-- Confirmation Section -->
              <div class="contact-box border-0"
                tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed tooltip-space" tooltipPosition="right"
                [pTooltip]="confirmationRecipientTooltip" [escape]="false">
                <div class="contact-header flex-between-center">
                  <span [pTooltip]="!isPastAppointment ? '' : 'Cannot send confirmation for appointments in past'"
                    tooltipPosition="top" class="flex-start-center pointer"
                    (click)="toggleAccordianState('confirmation', $event)">
                    <i class="font-width-10 font-12 flex-center-center contact-icon fal mb-1"
                      [ngClass]="{ 'fa-chevron-right': !appointment.accordion.confirmation, 'fa-chevron-down': appointment.accordion.confirmation }"></i>
                    <span class="font-14 mb-1 font-secondary-900 font-600">Send Confirmation</span>
                  </span>
                  <span class="custom-switch-pill flex-center-center mb-1">
                    <label class="switch switch-pill switch-success">
                      <input type="checkbox" name="displayMessage" class="switch-input"
                        [disabled]="isReminderDisabled || (!appointment.customer.email && !appointment.customer.phone)"
                        [(ngModel)]="appointment.switch.confirmation" />
                      <span class="switch-slider"></span>
                    </label>
                  </span>
                </div>

                <div class="font-12 flex-column position-relative">
                  <i class="far fa-edit pointer p-2 update-recipient-icon" tooltipPosition="top"
                    [ngClass]="{ 'not-allowed': !appointment.customer.contactOnPhone && !appointment.customer.contactOnEmail }"
                    [pTooltip]="!appointment.customer.contactOnPhone && !appointment.customer.contactOnEmail ? 'Select Email or Phone to add Recipients' : ''"
                    (click)="openUpdateRecipientDialog('confirmation')"></i>

                  <p class="flex-start-center mb-1 accordion-text">
                    <i class="fal fa-envelope flex-center-center contact-icon"></i>

                    <span *ngIf="recipients?.emails?.length === 1">
                      {{ (recipients?.emails)[0].value }}
                    </span>

                    <span *ngIf="recipients?.emails?.length !== 1">
                      <span [hidden]="recipients?.emails?.length">No email</span>
                      <span [hidden]="!recipients?.emails?.length"> {{ recipients?.emails?.length }} email addresses
                      </span>
                    </span>
                  </p>

                  <p class="flex-start-center mb-1 accordion-text">
                    <i class="fal fa-mobile flex-center-center contact-icon"></i>

                    <span *ngIf="recipients?.phones?.length === 1">
                      {{ (recipients?.phones)[0].value | mask : '(000) 000-0000' }}
                    </span>

                    <span *ngIf="recipients?.phones?.length !== 1">
                      <span [hidden]="recipients?.phones?.length">No phone</span>
                      <span [hidden]="!recipients?.phones?.length"> {{ recipients?.phones?.length }} mobile numbers
                      </span>
                    </span>
                  </p>

                  <p class="flex-start-center mb-1 accordion-text">
                    <i class="fal fa-info-circle text-dark flex-center-center contact-icon"></i>
                    <span>Will be sent when this appointment is saved</span>
                  </p>
                </div>

                <div class="custom-textarea" [hidden]="!appointment.accordion.confirmation">
                  <div class="font-12 outline-none" contenteditable="true"
                    (input)="handleChange('confirmation', $event)" #confirmationContentEl></div>
                </div>
              </div>
            </div>
          </p-tabPanel>

          <!-- Manual Confirmation starts -->
          <p-tabPanel header="Manually Confirm" [selected]="selectedTab === 1">
            <div>
              <!-- Confirmation Section -->
              <div class="contact-box border-0">
                <div class="contact-header flex-between-center">
                  <span class="flex-start-center pointer" (click)="toggleAccordianState('manualConfirmation', $event)">
                    <i class="font-width-10 font-12 flex-center-center contact-icon fal mb-1"
                      [ngClass]="{ 'fa-chevron-right': !appointment.accordion.manualConfirmation, 'fa-chevron-down': appointment.accordion.manualConfirmation }"></i>
                    <span class="font-14 mb-1 font-secondary-900 font-600"><span
                        [pTooltip]="!isPastAppointment ? '' : 'Cannot send confirmation for appointments in past'"
                        tooltipPosition="top">Confirmation status </span>
                      <span class="current-status text-capitalize" *ngIf="defaultAppointmentStatus">(Current Status:
                        {{
                        defaultAppointmentStatus }}) <i class="pl-2 fal fa-info-circle" tooltipPosition="right"
                          [pTooltip]="'Changing status will send an update'"></i></span></span>
                  </span>
                </div>

                <!-- Appointment status radio buttons -->
                <div class="flex-start-center mt-1 mb-15 label-14 bold">
                  <span class="pr-1 radio-inline">
                    <app-radio-button id="status-confirm" name="apt-status" label="Confirm"
                      styleClassLabel="font-seconday" [selectedValue]="appointment.status === 'confirmed'"
                      [value]="true" (appChange)="handleRadioChange('statusConfirm', $event)">
                    </app-radio-button>
                  </span>
                  <span class="pr-1 ml-4">
                    <app-radio-button id="status-decline" name="apt-status" label="Cancel"
                      styleClassLabel="font-seconday" [selectedValue]="appointment.status === 'cancelled'"
                      [value]="true" (appChange)="handleRadioChange('statusCancelled', $event)">
                    </app-radio-button>
                  </span>
                </div>

                <div class="font-12 flex-column position-relative">
                  <i class="far fa-edit pointer p-2 update-recipient-icon" tooltipPosition="top"
                    [ngClass]="{ 'not-allowed': !appointment.customer.contactOnPhone && !appointment.customer.contactOnEmail }"
                    [pTooltip]="!appointment.customer.contactOnPhone && !appointment.customer.contactOnEmail ? 'Select Email or Phone to add Recipients' : ''"
                    (click)="openUpdateRecipientDialog('confirmation')"></i>

                  <p class="flex-start-center mb-1 accordion-text">
                    <i class="fal fa-envelope flex-center-center contact-icon"></i>

                    <span *ngIf="recipients?.emails?.length === 1">
                      {{ (recipients?.emails)[0].value }}
                    </span>

                    <span *ngIf="recipients?.emails?.length !== 1">
                      <span [hidden]="recipients?.emails?.length">No email</span>
                      <span [hidden]="!recipients?.emails?.length"> {{ recipients?.emails?.length }} email addresses
                      </span>
                    </span>
                  </p>

                  <p class="flex-start-center mb-1 accordion-text">
                    <i class="fal fa-mobile flex-center-center contact-icon"></i>

                    <span *ngIf="recipients?.phones?.length === 1">
                      {{ (recipients?.phones)[0].value | mask : '(000) 000-0000' }}
                    </span>

                    <span *ngIf="recipients?.phones?.length !== 1">
                      <span [hidden]="recipients?.phones?.length">No phone</span>
                      <span [hidden]="!recipients?.phones?.length"> {{ recipients?.phones?.length }} mobile numbers
                      </span>
                    </span>
                  </p>

                  <p class="flex-start-center mb-1 accordion-text">
                    <i class="fal fa-info-circle text-dark flex-center-center contact-icon"></i>
                    <span>Will be sent when this appointment is saved</span>
                  </p>
                </div>
                <div class="custom-textarea" [hidden]="!appointment.accordion.manualConfirmation">
                  <div class="font-12 outline-none confirm" [hidden]="appointment.status === 'cancelled'"
                    contenteditable="true" (input)="handleChange('confirmReply', $event)" #manualConfirmationContentEl>
                  </div>
                  <div class="font-12 outline-none cancel" [hidden]="appointment.status === 'confirmed'"
                    contenteditable="true" (input)="handleChange('cancelReply', $event)" #manualCanceledContentEl>
                  </div>
                </div>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>

        <!-- Reminder Section -->
        <div [hidden]="!sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)"
          class="contact-box bg-white reminder-box br-3 mt-10 mb-0 reminder-section p-2"
          tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
          [pTooltip]="reminderRecipientTooltip" [escape]="false">
          <div class="contact-header flex-between-center" (click)="toggleAccordianState('reminders', $event)">
            <span [pTooltip]="!isPastAppointment ? '' : 'Cannot send reminders for appointments in past'"
              class="flex-start-center pointer">
              <i class="font-width-10 font-10 flex-center-center contact-icon mb-1 fal"
                [ngClass]="{ 'fa-chevron-right': !appointment?.accordion?.reminders, 'fa-chevron-down': appointment?.accordion?.reminders }"></i>
              <span class="font-14 mb-1 font-secondary-900 font-600">
                Reminder

                <i *ngIf="unsubscriptionTooltip" class="fal fa-exclamation-triangle font-yellow font-13"
                  tooltipPosition="top" [escape]="false" [pTooltip]="unsubscriptionTooltip"></i>
              </span>
            </span>

            <span class="custom-switch-pill flex-center-center mb-1">
              <label class="switch switch-pill switch-success">
                <input type="checkbox" name="reminderMessage" class="switch-input"
                  [disabled]="isReminderDisabled || (!appointment.customer.email && !appointment.customer.phone)"
                  [(ngModel)]="appointment.switch.reminders" />
                <span class="switch-slider"></span>
              </label>
            </span>
          </div>

          <div [hidden]="!sideAccordionVisible || (!appointment.customer.phone && !appointment.customer.email)"
            class="bg-white flex-start-start br-3 mb-0 mt-2 position-relative send-reminder">
            <app-checkbox label="" [fontSize]="11" [isChecked]="useConfirmationRecipient"
              [disabled]="isReminderDisabled || (!appointment.customer.email && !appointment.customer.phone)"
              (appChange)="handleUseConfirmationRecipientChange($event)"> </app-checkbox>

            <p class="m-0 font-11">Send reminders to same contacts as confirmation</p>
            <i class="far fa-edit pointer p-2 font-11 update-recipient-icon" tooltipPosition="top"
              [ngClass]="{ 'not-allowed': (!appointment.customer.contactOnPhone && !appointment.customer.contactOnEmail) || this.useConfirmationRecipient }"
              [pTooltip]="!appointment.customer.contactOnPhone && !appointment.customer.contactOnEmail ? 'Select Email or Phone to add Recipients' : ''"
              (click)="openUpdateRecipientDialog('reminder')"></i>
          </div>

          <div class="font-11 add-reminder-overlay position-relative">
            <p class="flex-start-center mb-1 accordion-text">
              <i class="fal fa-envelope flex-center-center contact-icon"></i>
              <span *ngIf="reminderRecipients?.emails?.length === 1; else multiConfirmationEmail">
                {{ (reminderRecipients?.emails)[0].value }}
              </span>

              <ng-template #multiConfirmationEmail>
                <span *ngIf="!reminderRecipients?.emails?.length">No email</span>
                <span *ngIf="reminderRecipients?.emails?.length"> {{ reminderRecipients?.emails?.length }} email
                  addresses </span>
              </ng-template>
            </p>

            <p class="flex-start-center mb-1 accordion-text">
              <i class="fal fa-mobile flex-center-center contact-icon"></i>
              <span *ngIf="reminderRecipients?.phones?.length === 1; else multiConfirmationPhone">
                {{ (reminderRecipients?.phones)[0].value | mask : '(000) 000-0000' }}
              </span>

              <ng-template #multiConfirmationPhone>
                <span *ngIf="!reminderRecipients?.phones?.length">No phone</span>
                <span *ngIf="reminderRecipients?.phones?.length"> {{ reminderRecipients?.phones?.length }} mobile
                  numbers </span>
              </ng-template>
            </p>

            <span id="appt-add-reminder" *ngIf="appointment.reminders?.length === 0" (click)="addReminder($event)"
              class="font-primary pointer"> Add </span>

            <span *ngIf="appointment.reminders?.length">
              Will be sent
              <span *ngFor="let reminder of appointment.reminders">
                <span [ngClass]="{ 'strike-through': !reminder.isActive }"> {{ reminder.frequency }} {{
                  renderPeriod(reminder.key, reminder.frequency) }},&nbsp; </span>
              </span>
              before&nbsp;
              <span id="appt-toggle-reminder" class="font-primary pointer" (click)="toggleAddReminder()">
                {{ isAddReminderOpen ? 'Hide' : 'Edit' }}
              </span>
            </span>
          </div>

          <div class="custom-textarea p-2" [hidden]="!appointment.accordion.reminders">
            <div class="font-12 outline-none" contenteditable="true" (input)="handleChange('reminder', $event)"
              #reminderContentEl></div>
          </div>

          <div *ngIf="isAddReminderOpen" class="add-reminder-wrapper bg-white pr-2 pl-2 pb-2">
            <div *ngFor="let reminder of appointment.reminders; let i = index"
              [ngClass]="{ 'disabled-reminder': !reminder.isActive }">
              <app-reminder-item [reminder]="reminder" [index]="i" (setDisabledReminders)="setDisabledReminders()"
                (reminderUpdate)="reminderDelete($event)"> </app-reminder-item>
            </div>

            <span id="btn-appt-add-reminder" *ngIf="appointment?.reminders?.length < 3"
              class="flex-start-center pointer" (click)="addReminder($event)">
              <i class="fas fa-plus-circle font-12 mr-2 font-primary"></i>
              <span class="font-10 font-primary">Add Reminder</span>
            </span>
          </div>
        </div>
      </div>

      <div class="ui-g-12 ui-lg-3 activity-log-container">
        <!-- Activity List -->
        <div class="activity-log-header">
          <h4>Activity log</h4>
        </div>

        <ng-container *ngIf="isLogsLoading else loadedLogsContainer">
          <div class="modal-empty-list" *ngIf="!activities.length">
            <i class="fal fa-spinner rotate font-16 mt-3"></i>
          </div>
        </ng-container>

        <ng-template #loadedLogsContainer>
          <div class="modal-empty-list" *ngIf="!activities.length">
            <p>Activity will be visible once the appointment is created</p>
          </div>

          <ul class="activity-list" *ngIf="activities">
            <div class="activity-list-item-wrapper" *ngFor="let activity of activities">
              <li class="activity-list-item flex-start-start" tooltipPosition="top"
                tooltipStyleClass="payment-history-tooltip" [pTooltip]="activity.title">
                <div>
                  <span class="icon">{{ activity.initial }}</span>
                </div>
                <div class="flex-column activity-title-wrapper">
                  <p class="mb-0 font-12 font-600 text-truncate activity-title">
                    {{ activity.title }}
                  </p>
                  <p class="mb-0 font-10 activity-title activity-user-logs">
                    by {{ activity.actionBy }} {{ activity.createdAt }}

                    <span *ngIf="activity?.data?.includeContact">
                      to
                      <span *ngIf="activity?.data?.type !== 'email'">
                        {{ activity?.data?.contact | mask : '(000) 000-0000' }}
                      </span>
                      <span *ngIf="activity?.data?.type === 'email'">
                        {{ activity?.data?.contact }}
                      </span>
                    </span>
                  </p>
                </div>
              </li>
              <li class="divider"></li>
              <li class="node"></li>
            </div>
          </ul>
        </ng-template>
      </div>
    </div>
  </div>
</div>
